import { React, useEffect, useContext } from 'react';
import { AppContext } from '../../services/AppContext';
import { useNavigate, useLocation } from 'react-router-dom';

const QR = () => {
    const { apiClient } = useContext(AppContext);
    const navigate = useNavigate();
    const location = useLocation();
    
    useEffect(() => {
        fetchData();
    },[]);

    const fetchData = async () => {
        const queryParams = new URLSearchParams(location.search);
        const id = queryParams.get('id');

        if (!id) {
            navigate('/');
            return;
        }
        const result = await apiClient.getQR(id);

        if(result.redirectUrl){
            window.location.href = result.redirectUrl;
        }
    };

    return (<div></div>);
  };

export default QR;